import type {
  MarketCategory,
  Purchase,
  PurchasedItem,
} from '@/entities/market/model/market.types';
import { type Prize } from '@/entities/wheel/model/wheel.types';

import { api } from '../api';

export const getProducts = async () => {
  const { data } = await api.get<MarketCategory[] | undefined>('v1/market');
  return data;
};

export const buy = async (purchase: Purchase): Promise<PurchasedItem> => {
  // Imitating purchase for development
  // if (import.meta.env.DEV) {
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve({
  //         url: '',
  //         item: { name: 'TEST ENV PURCHASE', promoCode: 'TEST ENV PROMOCODE' } as any,
  //       });
  //     }, 500);
  //   });
  // }

  const { data } = await api.post<PurchasedItem>('v1/market/buy', purchase);
  return data;
};

export const getPrizesByShopItemId = async (shopItemId: number) => {
  const { data } = await api.get<Prize[]>(`v1/market/prizes/${shopItemId}`);
  return data;
};

export const unsubsribe = async (shopItemId: number) => {
  const { data } = await api.put(`v1/market/unsubscribe/${shopItemId}`);
  return data;
};
